import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=21f8b622&"
import script from "./MenuWrapper.vue?vue&type=script&lang=ts&"
export * from "./MenuWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VDivider,VIcon,VScrollYReverseTransition})
